module.exports = __webpack_public_path__ + "img/hands-with-laptop-virtual-world-map.7eda9956.jpg";